import React, { Component } from 'react'
import { connect } from "react-redux";
import '../../../assets/styles/components/detail-center/financials.scss'
import * as echarts from "echarts";
import { stockActions } from "@/actions/trading/stock.action";
import { Converter, formatFunctions, utilsFunction,keyDownFunctions,accessibilityFunctions } from '@/helpers/functions';
import { getSafe } from '@/helpers/global';
import Dropdown from '../../../../../components/Dropdown/Dropdown.js';
import { dataType } from '@/constants/data-type';
import { SECURITY_FINANCIAL_REPORT_GROUP, SECURITY_FINANCIAL_GROUP } from '../../../../../constants/filterfinancial-type.js';
import { WS_LANG_KEY } from '@/constants/app';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { openMarkrtFinancialsDetail } from '@/actions/app'

class Financials extends Component {
	constructor(props) {
		super(props)
		this.state = {
			marketID: '',
			InstrumentID: '',
			FinancialsData: {},
			selectfilterOption: SECURITY_FINANCIAL_GROUP,
			selectedOrderFilterStatus: SECURITY_FINANCIAL_REPORT_GROUP[0].value,
			selectedOptionIndex: 0,
			FinancialsEcharts: {
			},
			FinancialsAlls: {},
			newFinancialsData: '',
			load: false,
		}
	}
	render() {
		const { language } = this.props;
		const filterOptions = SECURITY_FINANCIAL_GROUP;
		const { selectedOptionIndex, FinancialsData, FinancialsEcharts, FinancialsAllEcharts, FinancialsAlls, load } = this.state;
		const financialsOptions = SECURITY_FINANCIAL_REPORT_GROUP;
		const defaultSelected = financialsOptions.filter(item => item.value === this.state.selectedOrderFilterStatus)
		if (JSON.stringify(FinancialsEcharts) !== '{}') {
			this.getTransferEcharts(FinancialsEcharts)
		}
		return (
			<div className='financials_assembly-body'>
				<div className="financials_assembly">
				<LoadingLayer load={load} />
				<div id="Financials-container" className="Financials-container">
					<div id="Financials-header-container" className="Financials-header-container">
						<h1>{language.market_main_index}</h1>
					</div>
					<div id="Financials-centre-container" className="Financials-centre-container">
						{filterOptions.map((opt, index) => {
							return (<div key={opt.value} className={`financials-item ${index === selectedOptionIndex ? 'financials-item-active' : ''} flex-align-center`} 
							onClick={() => this.handleClickOption(opt, index)}
							onKeyDown={keyDownFunctions.handleEnterKeyDown(() =>this.handleClickOption(opt, index))}
							{...accessibilityFunctions.hasTabIndex()}>  
							{getSafe(() => language[opt.label], opt.label)}  
							</div>)
						})}
					</div>
					<div className="order-filter-dropdown-container">
						<Dropdown options={financialsOptions}
							selectedOptions={defaultSelected}
							innerRef={c => this.dropdownRef = c}
							onChange={(opt) => this.handleSelectOrderType(opt[0])}
						/>
					</div>
					<div id="main" style={{ width: '800px', height: '300px', marginTop: '20px', opacity: load ? '0' : JSON.stringify(FinancialsEcharts) !== '{}' ? "1" : '0' }} >

					</div>
					<h2 style={{
						textAlign: 'center', lineHeight: '200px', position: 'absolute', top: '100px', left: '41%', transform: 'translate(-50%)',
						display: JSON.stringify(FinancialsEcharts) !== '{}' ? "none" : 'block'
					}}>
						{language.common_no_data}
					</h2>
					<div id="Financials-tail-container" className="Financials-tail-container">
					<div id="Financials-firsttail-container" className="Financials-firsttail-container">
						<div id="Financials-firsttail-left-container" className="Financials-firsttail-left-container">
							<div id="Financials-tableone-container" className="Financials-tableone-container">
							  <span className="Financials-textleft-container">{language.financials_finances}</span>
							  <span className="Financials-textright-container" onClick={() => openMarkrtFinancialsDetail(0)} onKeyDown={keyDownFunctions.handleEnterKeyDown(() =>openMarkrtFinancialsDetail(0))}{...accessibilityFunctions.hasTabIndex()}>{language.financials_details} {'>'} </span>							
							</div>
							<div id="Financials-tabletwo-container" className="Financials-tabletwo-container">
							  <div id="Financials-table-two-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.market_eps}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.financialRatio?.earnPerShare ? this.Decimal(FinancialsAlls.financialRatio?.earnPerShare,2) : '-' }</span>
							  </div>
							 <div id="Financials-table-three-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.market_pen}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.financialRatio?.netAssetPerShare ? this.Decimal(FinancialsAlls.financialRatio?.netAssetPerShare,2) : '-'  }</span>
							 </div>
							 <div id="Financials-table-four-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_asset_liability_ratio}</span>
							   <span className="Financials-texttwo-container">{  FinancialsAlls?.DebtRatio ? (FinancialsAlls.DebtRatio) :'-' }</span>
							 </div>
							 <div id="Financials-table-five-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_return_on_equity_roe}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.financialRatio?.returnOnEquity ? this.Decimal(FinancialsAlls.financialRatio?.returnOnEquity,2,true) : '-'  }</span>
							 </div>
							 <div id="Financials-table-six-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_return_on_assets_roa}</span>
							   <span className="Financials-texttwo-container">{  FinancialsAlls.financialRatio?.returnOnTotalAssets ? this.Decimal(FinancialsAlls.financialRatio?.returnOnTotalAssets,2,true) : '-' }</span>
							 </div>
							</div>	
						</div>
						<div id="Financials-firsttail-right-container" className="Financials-firsttail-right-container">
							<div id="Financials-tableone-container" className="Financials-tableone-container">
							  <span className="Financials-textleft-container">{language.financials_income_statement}</span>
							  <span className="Financials-textright-container" onClick={() => openMarkrtFinancialsDetail(1)} onKeyDown={keyDownFunctions.handleEnterKeyDown(() =>openMarkrtFinancialsDetail(1))}{...accessibilityFunctions.hasTabIndex()}>{language.financials_details} {'>'}</span>							
							</div>
							<div id="Financials-tabletwo-container" className="Financials-tabletwo-container">
							  <div id="Financials-table-two-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_revenue}</span>
							   <span className="Financials-texttwo-container">{ FinancialsAlls.profitLoss?.turnover ?   this.NumericalTransformation(FinancialsAlls.profitLoss?.turnover) : '-'}</span>
							  </div>
							 <div id="Financials-table-three-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_operating_lncome}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.profitLoss?.operatingProfitLoss ?   this.NumericalTransformation(FinancialsAlls.profitLoss?.operatingProfitLoss) : '-' }</span>
							 </div>
							 <div id="Financials-table-four-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_pre_tax_lncome}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.profitLoss?.profitLossBeforeTaxation ?   this.NumericalTransformation(FinancialsAlls.profitLoss?.profitLossBeforeTaxation) : '-' }</span>
							 </div>
							 <div id="Financials-table-five-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_net_lncome}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.profitLoss?.netProfitLoss ?   this.NumericalTransformation(FinancialsAlls.profitLoss?.netProfitLoss) : '-' }</span>
							 </div>
							 <div id="Financials-table-six-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_basic_eps}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.profitLoss?.basicEarnPerShare ?   this.Decimal(FinancialsAlls.profitLoss?.basicEarnPerShare,2) : '-'}</span>
							 </div>
							</div>	
						</div>
					</div>
					<div id="Financials-twotail-container" className="Financials-twotail-container">
					<div id="Financials-firsttail-left-container" className="Financials-firsttail-left-container">
							<div id="Financials-tableone-container" className="Financials-tableone-container">
							  <span className="Financials-textleft-container">{language.financials_balance_sheet}</span>
							  <span className="Financials-textright-container" onClick={() => openMarkrtFinancialsDetail(2)} onKeyDown={keyDownFunctions.handleEnterKeyDown(() =>openMarkrtFinancialsDetail(2))}{...accessibilityFunctions.hasTabIndex()}>{language.financials_details} {'>'} </span>							
							</div>
							<div id="Financials-tabletwo-container" className="Financials-tabletwo-container">
							  <div id="Financials-table-two-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_total_assets}</span>
							   <span className="Financials-texttwo-container">
							   {  !FinancialsAlls.balanceSheet?.cashAndShortTermFunds && !FinancialsAlls.balanceSheet?.inventory && !FinancialsAlls.balanceSheet?.otherCurrentAssets &&  !FinancialsAlls.balanceSheet?.intangibleAssets
								&& !FinancialsAlls.balanceSheet?.fixedAssets && !FinancialsAlls.balanceSheet?.otherAssets ? '-' :
									this.NumericalTransformation((Number(FinancialsAlls.balanceSheet?.cashAndShortTermFunds)+Number(FinancialsAlls.balanceSheet?.inventory)+Number(FinancialsAlls.balanceSheet?.otherCurrentAssets)
									+Number(FinancialsAlls.balanceSheet?.fixedAssets)+Number(FinancialsAlls.balanceSheet?.intangibleAssets)+Number(FinancialsAlls.balanceSheet?.otherAssets)).toString())  }
							   </span>
							  </div>
							 <div id="Financials-table-three-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_total_liabilities}</span>
							   <span className="Financials-texttwo-container">
								{  !FinancialsAlls.balanceSheet?.payables  && !FinancialsAlls.balanceSheet?.otherLiabilities && !FinancialsAlls.balanceSheet?.longTermDebt && !FinancialsAlls.balanceSheet?.otherCurrentLiabilities ?  '-' :
							   	this.NumericalTransformation((Number(FinancialsAlls.balanceSheet.payables)+Number(FinancialsAlls.balanceSheet.otherLiabilities)+Number(FinancialsAlls.balanceSheet.longTermDebt)
								+Number(FinancialsAlls.balanceSheet.otherCurrentLiabilities)).toString()) }
							   </span>
							 </div>
							 <div id="Financials-table-four-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_total_owners}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.balanceSheet?.shareHoldersEquity ?   this.NumericalTransformation(FinancialsAlls.balanceSheet?.shareHoldersEquity) : '-'}</span>
							 </div>
							</div>	
						</div>
						<div id="Financials-firsttail-right-container" className="Financials-firsttail-right-container">
							<div id="Financials-tableone-container" className="Financials-tableone-container">
							  <span className="Financials-textleft-container">{language.financials_cash_flow__statement}</span>
							  <span className="Financials-textright-container" onClick={() => openMarkrtFinancialsDetail(3)} onKeyDown={keyDownFunctions.handleEnterKeyDown(() =>openMarkrtFinancialsDetail(3))}{...accessibilityFunctions.hasTabIndex()}>{language.financials_details} {'>'} </span>							
							</div>
							<div id="Financials-tabletwo-container" className="Financials-tabletwo-container">
							  <div id="Financials-table-two-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_net_cash_operating}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.cashFlow?.netCashFlowFromOperating ?   this.NumericalTransformation(FinancialsAlls.cashFlow?.netCashFlowFromOperating) : '-'}</span>
							  </div>
							 <div id="Financials-table-three-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_net_cash_investing}</span>
							   <span className="Financials-texttwo-container">{FinancialsAlls.cashFlow?.netCashFlowFromInvesting ?   this.NumericalTransformation(FinancialsAlls.cashFlow?.netCashFlowFromInvesting) : '-'}</span>
							 </div>
							 <div id="Financials-table-four-container" className="Financials-table-two-container">
							   <span className="Financials-textone-container">{language.financials_net_cash_fnancing}</span>
							   <span className="Financials-texttwo-container"> {  FinancialsAlls.cashFlow?.netCashFlowFromFinancing ?   this.NumericalTransformation(FinancialsAlls.cashFlow?.netCashFlowFromFinancing) : '-'}</span>
							 </div>
							</div>	
						</div>
					</div>
				 </div>
				</div>
			</div>
			</div>
			
		)
	}
	componentDidMount() {
		this.props.innerRef(this)
		const { marketParams } = this.props;
		const { marketID, stockCode } = marketParams;
		this.setState({
			marketID: marketID,
			InstrumentID: stockCode
		}, () => {
			this.getFinancials();
		})
	}

	componentDidUpdate(preProps) {
		const { currentTradingAccount, isNeedRefresh, language, mdsToken, marketParams } = this.props
		const { selectedOptionIndex } = this.state
		const filterOptionsData = SECURITY_FINANCIAL_GROUP[selectedOptionIndex];
		if (language && preProps.language !== language) {
			this.resetGetData()
		}
		if (marketParams && preProps.marketParams !== marketParams) {
			this.resetGetData()
		}

	}

	resetGetData = () => {
		const { marketParams } = this.props
		const { marketID, stockCode } = marketParams;
		const financialsOptions = SECURITY_FINANCIAL_REPORT_GROUP
		this.setState({
			marketID: marketID,
			InstrumentID: stockCode,
			selectedOptionIndex: 0
		}, () => {
			this.getFinancials()
			this.dropdownRef.setValue([financialsOptions[0]])
		})
	}

	handleSelectOrderType(key) {
		const { newFinancialsData, FinancialsData, FinancialsEcharts, selectedOrderFilterStatus, selectedOptionIndex, selectfilterOption } = this.state;
		const { language } = this.props;
		const filterOptionsData = SECURITY_FINANCIAL_GROUP[selectedOptionIndex];
		const filterOptionsIndex = SECURITY_FINANCIAL_GROUP[selectedOptionIndex].value;
		const FinancialspushData = [];
		if (key.value !== "all") {
			newFinancialsData.forEach((opt) => {
				if (key.value == opt.quarter) {
					FinancialspushData.push(opt)
				}
			})
			if (FinancialspushData.length > 0) {
				const YearEndtime = [];
				const YaxisdDta = [];
				const PercentAge = [];
				const Columntitle = language[filterOptionsData.label];
				const Polylinetitle = language.financials_year_on_year;
				FinancialspushData.forEach((opt) => {
					if (filterOptionsIndex == "revenue") {
						YearEndtime.push(opt.basicInfo.yearEndDate);
						YaxisdDta.push(opt.profitLoss.turnover);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
								const Currentperiod = pro.profitLoss.turnover;
								const Contemporaneous = FinancialsData[opt.quarter][index + 1].profitLoss.turnover;
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									PercentAge.push(0)
								}
							}
						})
					} else if (filterOptionsIndex == "net_profit") {
						YearEndtime.push(opt.basicInfo.yearEndDate);
						YaxisdDta.push(opt.profitLoss.netProfitLoss);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
								const Currentperiod = pro.profitLoss.netProfitLoss;
								const Contemporaneous = FinancialsData[opt.quarter][index + 1].profitLoss.netProfitLoss;
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									PercentAge.push(0)
								}
							}
						})
					} else if (filterOptionsIndex == "eps") {
						YearEndtime.push(opt.basicInfo.yearEndDate);
						YaxisdDta.push(opt.financialRatio.earnPerShare);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
								const Currentperiod = pro.financialRatio.earnPerShare;
								const Contemporaneous = FinancialsData[opt.quarter][index + 1].financialRatio.earnPerShare;
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									PercentAge.push(0)
								}
							}
						})
					} else if (filterOptionsIndex == "pen") {
						YearEndtime.push(opt.basicInfo.yearEndDate);
						YaxisdDta.push(opt.financialRatio.netassetpershare);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
								const Currentperiod = pro.financialRatio.netassetpershare;
								const Contemporaneous = FinancialsData[opt.quarter][index + 1].financialRatio.netassetpershare;
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									PercentAge.push(0)
								}
							}
						})
					} else if (filterOptionsIndex == "gross_margin") {
						YearEndtime.push(opt.basicInfo.yearEndDate);
						YaxisdDta.push(opt.financialRatio.grossProfitRatio);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
								const Currentperiod = pro.financialRatio.grossProfitRatio;
								const Contemporaneous = FinancialsData[opt.quarter][index + 1].financialRatio.grossProfitRatio;
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									PercentAge.push(0)
								}
							}
						})
					} else if (filterOptionsIndex == "basic_earnings_per_share") {
						YearEndtime.push(opt.basicInfo.yearEndDate);
						YaxisdDta.push(opt.profitLoss.basicEarnPerShare);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
								const Currentperiod = pro.profitLoss.basicEarnPerShare;
								const Contemporaneous = FinancialsData[opt.quarter][index + 1].profitLoss.basicEarnPerShare;
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									PercentAge.push(0)
								}
							}
						})
					} else if (filterOptionsIndex == "return_on_equity") {
						YearEndtime.push(opt.basicInfo.yearEndDate);
						YaxisdDta.push(opt.financialRatio.returnOnEquity);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
								const Currentperiod = pro.financialRatio.returnOnEquity;
								const Contemporaneous = FinancialsData[opt.quarter][index + 1].financialRatio.returnOnEquity;
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									PercentAge.push(0)
								}
							}
						})
					} else if (filterOptionsIndex == "ebt_ratio") {
						let debtratio = null
						YearEndtime.push(opt.basicInfo.yearEndDate);
						const Totalliabilities = Number(opt.balanceSheet.payables) + Number(opt.balanceSheet.otherLiabilities) + Number(opt.balanceSheet.longTermDebt)
							+ Number(opt.balanceSheet.otherCurrentLiabilities);
						const Totalassets = Number(opt.balanceSheet.cashAndShortTermFunds) + Number(opt.balanceSheet.inventory) + Number(opt.balanceSheet.otherCurrentAssets)
							+ Number(opt.balanceSheet.fixedAssets) + Number(opt.balanceSheet.intangibleAssets) + Number(opt.balanceSheet.otherAssets);
							if(!opt.balanceSheet.payables && !opt.balanceSheet.otherLiabilities && !opt.balanceSheet.otherCurrentLiabilities && !opt.balanceSheet.cashAndShortTermFunds
								&& !opt.balanceSheet.inventory&& !opt.balanceSheet.otherCurrentAssets && !opt.balanceSheet.fixedAssets&& !opt.balanceSheet.intangibleAssets && !opt.balanceSheet.otherAssets){
								debtratio = '0.00'
							}else{
								debtratio = (Totalliabilities / Totalassets * 100).toFixed(2);
							}
						const newdebtratio = debtratio.concat("%")
						YaxisdDta.push(debtratio);
						FinancialsData[opt.quarter].forEach((pro, index) => {
							if (opt.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
							const Totalliabilitiesone = Number(opt.balanceSheet.payables) + Number(opt.balanceSheet.otherLiabilities) + Number(opt.balanceSheet.longTermDebt)
								+ Number(opt.balanceSheet.otherCurrentLiabilities);
							const Totalassetsone = Number(opt.balanceSheet.cashAndShortTermFunds) + Number(opt.balanceSheet.inventory) + Number(opt.balanceSheet.otherCurrentAssets)
								+ Number(opt.balanceSheet.fixedAssets) + Number(opt.balanceSheet.intangibleAssets) + Number(opt.balanceSheet.otherAssets);
							const debtratioone = (Totalliabilitiesone / Totalassetsone * 100).toFixed(2);
							const Currentperiod = debtratioone;
							const Totalliabilitiestwo = Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.payables) + Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.otherLiabilities)
								+ Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.longTermDebt) + Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.otherCurrentLiabilities);
							const Totalassetstwo = Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.cashAndShortTermFunds) + Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.inventory)
								+ Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.otherCurrentAssets) + Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.fixedAssets)
								+ Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.intangibleAssets) + Number(FinancialsData[opt.quarter][index + 1]?.balanceSheet.otherAssets);
							const debtratiotwo = (Totalliabilitiestwo / Totalassetstwo * 100).toFixed(2);
							const Contemporaneous = debtratiotwo;
							if(!opt.balanceSheet.payables && !opt.balanceSheet.otherLiabilities && !opt.balanceSheet.otherCurrentLiabilities && !opt.balanceSheet.cashAndShortTermFunds
								&& !opt.balanceSheet.inventory&& !opt.balanceSheet.otherCurrentAssets && !opt.balanceSheet.fixedAssets&& !opt.balanceSheet.intangibleAssets && !opt.balanceSheet.otherAssets){
									PercentAge.push('0.00')   
							   }else {
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									  PercentAge.push('0.00')
								}
							 }
						}
						})
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})

			} else {
				this.setState({ FinancialsEcharts: {} })
			}
		} else {
			this.handleClickOption(filterOptionsData, selectedOptionIndex, true);
		}
		if (key.value !== selectedOrderFilterStatus) {
			this.setState({ selectedOrderFilterStatus: key.value })
		}
	}

	handleClickOption = (opt, index, isall = false) => {
		const { selectedOptionIndex, FinancialsData, selectedOrderFilterStatus, newFinancialsData } = this.state;
		const { language } = this.props;
		const FinancialspushData = [];
		const YearEndtime = [];
		const YaxisdDta = [];
		const PercentAge = [];
		const Polylinetitle = language.financials_year_on_year;
		const filterOptionsData = SECURITY_FINANCIAL_GROUP[selectedOptionIndex];
		if (filterOptionsData === opt && !isall) return
		const financialsOptions = SECURITY_FINANCIAL_REPORT_GROUP
		this.dropdownRef.setValue([financialsOptions[0]])
		newFinancialsData.forEach((opts) => {
			YearEndtime.push(opts.basicInfo.yearEndDate);
			if (opt.value == "revenue") {
				const Columntitle = language[opt.label];
				YaxisdDta.push(opts.profitLoss.turnover);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Currentperiod = pro.profitLoss.turnover;
						const Contemporaneous = FinancialsData[opts.quarter][index + 1].profitLoss.turnover;
						if (Number(Contemporaneous)) {
							const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
							PercentAge.push(percentage)
						} else {
              PercentAge.push('0.00')
						}
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})

			} else if (opt.value == "net_profit") {
				const Columntitle = language[opt.label];
				YaxisdDta.push(opts.profitLoss.netProfitLoss);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Currentperiod = pro.profitLoss.netProfitLoss;
						const Contemporaneous = FinancialsData[opts.quarter][index + 1].profitLoss.netProfitLoss;
						if (Number(Contemporaneous)) {
							const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
							PercentAge.push(percentage)
						} else {
              				PercentAge.push('0.00')
						}
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})
			} else if (opt.value == "eps") {
				const Columntitle = language[opt.label];
				YaxisdDta.push(opts.financialRatio.earnPerShare);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Currentperiod = pro.financialRatio.earnPerShare;
						const Contemporaneous = FinancialsData[opts.quarter][index + 1].financialRatio.earnPerShare;
						if (Contemporaneous) {
							const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
							PercentAge.push(percentage)
						} else {
              PercentAge.push('0.00')
						}
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})
			} else if (opt.value == "pen") {
				const Columntitle = language[opt.label];
				YaxisdDta.push(opts.financialRatio.netassetpershare);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Currentperiod = pro.financialRatio.netassetpershare;
						const Contemporaneous = FinancialsData[opts.quarter][index + 1].financialRatio.netassetpershare;
						if (Number(Contemporaneous)) {
							const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
							PercentAge.push(percentage)
						} else {
              PercentAge.push('0.00')
						}
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})
			} else if (opt.value == "gross_margin") {
				const Columntitle = language[opt.label];
				YaxisdDta.push(opts.financialRatio.grossProfitRatio);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Currentperiod = pro.financialRatio.grossProfitRatio;
						const Contemporaneous = FinancialsData[opts.quarter][index + 1].financialRatio.grossProfitRatio;
						if (Number(Contemporaneous)) {
							const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
							PercentAge.push(percentage)
						} else {
              PercentAge.push('0.00')
						}
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})
			} else if (opt.value == "basic_earnings_per_share") {
				const Columntitle = language[opt.label];
				YaxisdDta.push(opts.profitLoss.basicEarnPerShare);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Currentperiod = pro.profitLoss.basicEarnPerShare;
						const Contemporaneous = FinancialsData[opts.quarter][index + 1].profitLoss.basicEarnPerShare;
						if (Number(Contemporaneous)) {
							const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
							PercentAge.push(percentage)
						} else {
              PercentAge.push('0.00')
						}
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})
			} else if (opt.value == "return_on_equity") {
				const Columntitle = language[opt.label];
				const ReturnOnEquity = opts.financialRatio.returnOnEquity;
				//   const newReturnOnEquity=(ReturnOnEquity).toFixed(2);
				YaxisdDta.push(ReturnOnEquity);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Currentperiod = pro.financialRatio.returnOnEquity;
						const Contemporaneous = FinancialsData[opts.quarter][index + 1].financialRatio.returnOnEquity;
						if (Contemporaneous) {
							const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
							PercentAge.push(percentage)
						} else {
              PercentAge.push('0.00')
						}
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})
			} else if (opt.value == "ebt_ratio") {
				let debtratio = null
				const Columntitle = language[opt.label];
				const Totalliabilities = Number(opts.balanceSheet.payables) + Number(opts.balanceSheet.otherLiabilities) + Number(opts.balanceSheet.longTermDebt)
					+ Number(opts.balanceSheet.otherCurrentLiabilities);
				const Totalassets = Number(opts.balanceSheet.cashAndShortTermFunds) + Number(opts.balanceSheet.inventory) + Number(opts.balanceSheet.otherCurrentAssets)
					+ Number(opts.balanceSheet.fixedAssets) + Number(opts.balanceSheet.intangibleAssets) + Number(opts.balanceSheet.otherAssets);
					if(!opts.balanceSheet.payables && !opts.balanceSheet.otherLiabilities && !opts.balanceSheet.otherCurrentLiabilities && !opts.balanceSheet.cashAndShortTermFunds
						&& !opts.balanceSheet.inventory&& !opts.balanceSheet.otherCurrentAssets && !opts.balanceSheet.fixedAssets&& !opts.balanceSheet.intangibleAssets && !opts.balanceSheet.otherAssets){
						 debtratio = '0.00'
					}else{
						debtratio = (Totalliabilities / Totalassets * 100).toFixed(2);
					}
				
				const newdebtratio = debtratio.concat("%")
				YaxisdDta.push(debtratio);
				FinancialsData[opts.quarter].forEach((pro, index) => {
					if (opts.balanceSheet.otherAssets == pro.balanceSheet.otherAssets) {
						const Totalliabilitiesone = Number(opts.balanceSheet.payables) + Number(opts.balanceSheet.otherLiabilities) + Number(opts.balanceSheet.longTermDebt)
							+ Number(opts.balanceSheet.otherCurrentLiabilities);
						const Totalassetsone = Number(opts.balanceSheet.cashAndShortTermFunds) + Number(opts.balanceSheet.inventory) + Number(opts.balanceSheet.otherCurrentAssets)
							+ Number(opts.balanceSheet.fixedAssets) + Number(opts.balanceSheet.intangibleAssets) + Number(opts.balanceSheet.otherAssets);
						const debtratioone = (Totalliabilitiesone / Totalassetsone * 100).toFixed(2);
						const Currentperiod = debtratioone;
						const Totalliabilitiestwo = Number(FinancialsData[opts.quarter][index + 1].balanceSheet.payables) + Number(FinancialsData[opts.quarter][index + 1].balanceSheet.otherLiabilities)
							+ Number(FinancialsData[opts.quarter][index + 1].balanceSheet.longTermDebt) + Number(FinancialsData[opts.quarter][index + 1].balanceSheet.otherCurrentLiabilities);
						const Totalassetstwo = Number(FinancialsData[opts.quarter][index + 1].balanceSheet.cashAndShortTermFunds) + Number(FinancialsData[opts.quarter][index + 1].balanceSheet.inventory)
							+ Number(FinancialsData[opts.quarter][index + 1].balanceSheet.otherCurrentAssets) + Number(FinancialsData[opts.quarter][index + 1].balanceSheet.fixedAssets)
							+ Number(FinancialsData[opts.quarter][index + 1].balanceSheet.intangibleAssets) + Number(FinancialsData[opts.quarter][index + 1].balanceSheet.otherAssets);
						const debtratiotwo = (Totalliabilitiestwo / Totalassetstwo * 100).toFixed(2);
						const Contemporaneous = debtratiotwo;
						if(!opts.balanceSheet.payables && !opts.balanceSheet.otherLiabilities && !opts.balanceSheet.otherCurrentLiabilities && !opts.balanceSheet.cashAndShortTermFunds
							 && !opts.balanceSheet.inventory&& !opts.balanceSheet.otherCurrentAssets && !opts.balanceSheet.fixedAssets&& !opts.balanceSheet.intangibleAssets && !opts.balanceSheet.otherAssets){
								PercentAge.push('0.00')
							}else {
								if (Number(Contemporaneous)) {
									const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
									PercentAge.push(percentage)
								} else {
									  PercentAge.push('0.00')
								}
						  }
						
					}
				})
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					}
				})
			}

		})
		if (index !== selectedOptionIndex) {
			this.setState({ selectedOptionIndex: index })
		}

	}

	getFinancials = () => {
		this.setState({ load: true })
		const { language, mdsToken } = this.props;
		let { marketID, InstrumentID, selectfilterOption, selectedOptionIndex } = this.state
		marketID = Converter.mappingWebSocketMarket(marketID);
		let stockID = InstrumentID;
		stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
		if (stockID > -1) {
			stockID = this.state.InstrumentID.substr(stockID)
		}
		const dparams = {
			symbol: { exchangeID: marketID, key: stockID },
			sessID: mdsToken
		}
		this.props.getgetFinancialsInfo(dparams, quetores => {
			if (quetores) {
				const FinancialsData = quetores.data;
				const FinancialsTime = [];
				this.setState({ FinancialsData: FinancialsData })
				const yearEndDate = [];
				for (var item in FinancialsData) {

					FinancialsData[item].forEach((opt) => {
						yearEndDate.push(opt.basicInfo.yearEndDate)
						yearEndDate.sort(function (a, b) {
							return b - a
						})
					})
				}
				for (let i = 0; i < 5; i++) {
					FinancialsTime.push(yearEndDate[i])
				}
				FinancialsTime.sort(function (a, b) {
					return a - b
				})
				const newFinancialsData = [];
				FinancialsTime.forEach((opts) => {
					for (var item in FinancialsData) {
						FinancialsData[item].forEach((opt, index) => {
							if (opts == opt.basicInfo.yearEndDate) {
								function add(name, value) {
									opt[name] = value;
								}
								add("quarter", item)
								newFinancialsData.push(opt)
							}
						})
					}
				})
				const YearEndtime = [];
				const YaxisdDta = [];
				const PercentAge = [];
				const FinancialsAllEcharts = [];
				const Columntitle = language[selectfilterOption[0].label];
				const Polylinetitle = language.financials_year_on_year;
				newFinancialsData.forEach((items, index) => {
					if (index == newFinancialsData.length - 1) {
						FinancialsAllEcharts.push(items)
					}
					const datatime = formatFunctions.dataFormat(items.basicInfo.yearEndDate, dataType.SHORT_DATE);
					const reg = /(\d{4})\-(\d{2})\-(\d{2})/;
					const datenewtime = datatime.replace(reg, "$1");
					YaxisdDta.push(items.profitLoss.turnover);
					if (items.quarter == "S1") {
						const datanewmonthtime = language.financials_one_quarter
						let monthtime = datenewtime.concat(" ", datanewmonthtime);
						items.basicInfo.yearEndDate = monthtime;
						YearEndtime.push(monthtime)
					}
					if (items.quarter == "S2") {
						const datanewmonthtime = language.financials_interim
						let monthtime = datenewtime.concat(" ", datanewmonthtime);
						items.basicInfo.yearEndDate = monthtime;
						YearEndtime.push(monthtime)
					}
					if (items.quarter == "S3") {
						const datanewmonthtime = language.financials_three_quartert
						let monthtime = datenewtime.concat(" ", datanewmonthtime);
						items.basicInfo.yearEndDate = monthtime;
						YearEndtime.push(monthtime)
					}
					if (items.quarter == "S4") {
						const datanewmonthtime = language.financials_annual
						let monthtime = datenewtime.concat(" ", datanewmonthtime);
						items.basicInfo.yearEndDate = monthtime;
						YearEndtime.push(monthtime)
					}
					FinancialsData[items.quarter].forEach((pro, index) => {
						if (items.basicInfo.yearEndDate == pro.basicInfo.yearEndDate) {
							const Currentperiod = pro.profitLoss.turnover;
							const Contemporaneous = FinancialsData[items.quarter][index + 1].profitLoss.turnover;
							if (Contemporaneous) {
								const percentage = ((Currentperiod - Contemporaneous) / Contemporaneous * 100).toFixed(2)
								PercentAge.push(percentage)
							} else {

							}
						}
					})
				})
				
				const FinancialsAlls=FinancialsAllEcharts[0];
				let Totalliabilities = null
				let Totalassets= null
				let debtratio = null
				Totalliabilities=Number(FinancialsAlls.balanceSheet.payables)+Number(FinancialsAlls.balanceSheet.otherLiabilities)+Number(FinancialsAlls.balanceSheet.longTermDebt)
									+Number(FinancialsAlls.balanceSheet.otherCurrentLiabilities);
				Totalassets=Number(FinancialsAlls.balanceSheet.cashAndShortTermFunds)+Number(FinancialsAlls.balanceSheet.inventory)+Number(FinancialsAlls.balanceSheet.otherCurrentAssets)
				+Number(FinancialsAlls.balanceSheet.fixedAssets)+Number(FinancialsAlls.balanceSheet.intangibleAssets)+Number(FinancialsAlls.balanceSheet.otherAssets);
				if(Totalassets != 0){
					  debtratio=(Totalliabilities/Totalassets*100).toFixed(2) + '%';
				} 
        		function add(name,value){
					FinancialsAlls[name]=value;
				}
				add("DebtRatio", debtratio)
				this.setState({ newFinancialsData: newFinancialsData })
				this.setState({
					FinancialsEcharts: {
						YearEndtime: YearEndtime,
						YaxisdDta: YaxisdDta,
						PercentAge: PercentAge,
						Columntitle: Columntitle,
						Polylinetitle: Polylinetitle
					},
					FinancialsAlls: FinancialsAlls,
					load: false
				})
				this.getTransferEcharts(this.state.FinancialsEcharts);
			};

		})
	}

	getTransferEcharts = (opt) => {
		var chartDom = document.getElementById('main');
		var myChart = echarts.init(chartDom);
		var PercentageData = [];
		var PercenTage = [];
		var Percentage = opt.PercentAge;
		if (Percentage) {
			Percentage.forEach((item) => {
				const PercenTagenumber = Number(item)
				const PercentAge = item + "%"
				PercentageData.push(PercentAge)
				PercenTage.push(PercenTagenumber)
			})
		}
		var option;
		const colors = ['#1996e3', "#f5b72a",];
		const { theme } = this.props
		const { selectedOptionIndex } = this.state
		const NumericalTransformation = this.NumericalTransformation.bind(this)
		const Decimal = this.Decimal.bind(this)
		const formatterTipLine =this.formatterTipLine.bind(this)
		option = {
			color: colors,
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'cross',
				},
				formatter: function (params) {
					if(!params[0].value) return "" 
					if (selectedOptionIndex === 0 || selectedOptionIndex === 1) {
						return formatterTipLine(params,'cash')
					}else if(selectedOptionIndex === 2 || selectedOptionIndex === 3 ||  selectedOptionIndex === 5){
						return formatterTipLine(params , 'default')
					}else if(selectedOptionIndex === 6){
						return formatterTipLine(params, 'precent')
					}else{
						return formatterTipLine(params)
					}
				}
			},
			grid: {
				left: "3%"
			},
			legend: [{
				left: 0,
				data: [opt.Columntitle],
				textStyle: { color: theme === 'light' ? '#393939' : 'white' },
			},
			{
				left: "20%",
				data: [opt.Polylinetitle],
				textStyle: { color: theme === 'light' ? '#393939' : 'white' },
			}
			],
			xAxis: [
				{
					type: 'category',
					axisTick: {
						alignWithLabel: true
					},
					axisLabel: {
						interval: 0,

					},
					axisLine: {
						onZero: false
					},
					data: opt.YearEndtime
				},
				{
					type: 'category',
					position: 'bottom',
					offset: 25,
					axisTick: {
						show: false
					},
					axisLine: {
						lineStyle: {
							color: '#1996e3'
						}
					},
					data: PercentageData
				}
			],
			yAxis: [
				{
					type: 'value',
					name: '',
					position: 'left',
					interval: 50,
					splitLine: {
						show: false
					},
					axisLine: {
						show: false,
					},
					axisLabel: {
						formatter: function () {
							return "";
						}
					}
				},
				{
					type: 'value',
					name: '',
					position: 'right',
					interval: 5,
					splitLine: {
						show: false
					},
					axisLine: {
						show: false,
					},
					axisLabel: {
						formatter: function () {
							return "";
						}
					}
				}
			],

			series: [
				{
					name: opt.Columntitle,
					type: 'bar',
					barWidth: '20%',
					label: {
						show: true,
						position: 'top',
						color:  theme === 'light' ? '#393939' : 'white' ,
						formatter: function (params) {
							if (selectedOptionIndex === 0 || selectedOptionIndex === 1) {
								let data = NumericalTransformation(params.value)
								return data
							} else if (selectedOptionIndex === 4 || selectedOptionIndex === 6 || selectedOptionIndex === 7) {
								let data = Decimal(params.value, 2, true)
								return data
							} else {
								let data = Decimal(params.value, 2)
								return data
							}
						}
					},
					data: opt.YaxisdDta
				},
				{
					name: opt.Polylinetitle,
					type: 'line',
					yAxisIndex: 1,
					// label:{
					// 	show:true,
					// 	 position:'bottom' ,
					// 	 color:'blue'
					// },
					data: PercenTage
				}
			]
		};
		option && myChart.setOption(option);
	}


	NumericalTransformation(num) {
		if (num) {
			const language = utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
			let negative = ''
			if (num.includes('-')) {
				negative = '-'
				num = num.substr(1, (num.length + 1))
			}
			if (language == 'en') {
				if (num.length >= 10) {
					if ((num / 1000000000).toString().includes('.')) {
						return negative + (num / 1000000000).toString().split('.')[0] + '.' + (num / 1000000000).toString().split('.')[1].substr(0, 2) + 'B'
					} else {
						return negative + (num / 1000000000) + 'B'
					}
				} else if (num.length >= 7) {
					if ((num / 1000000).toString().includes('.')) {
						return negative + (num / 1000000).toString().split('.')[0] + '.' + (num / 1000000).toString().split('.')[1].substr(0, 2) + 'M'
					} else {
						return negative + (num / 1000000) + 'M'
					}
				} else return num
			} else {
				if (num.length >= 9) {
					if ((num / 100000000).toString().includes('.')) {
						return negative + (num / 100000000).toString().split('.')[0] + '.' + (num / 100000000).toString().split('.')[1].substr(0, 2) + '亿'
					} else {
						return negative + (num / 100000000) + '亿'
					}
				} else if (num.length >= 5) {
					if ((num / 10000).toString().includes('.')) {
						return negative + (num / 10000).toString().split('.')[0] + '.' + (num / 10000).toString().split('.')[1].substr(0, 2) + '万'
					} else {
						return negative + (num / 10000) + '万'
					}
				} else return num
			}
		} else {
			return num
		}
	}
	Decimal(num, x, Percentage = false) {
		if (num) {
			let placeholder = ' '
			if (Percentage) placeholder = '%'
			else placeholder = ' '
			return num.split('.')[0] + '.' + num.split('.')[1].substr(0, x) + placeholder
		}
	}

	 formatterTipLine (params, type) {
		var tip = '<span style="font-weight:blod">'+ params[0].axisValue + '</span>' +'<br>' ;
		if(type == 'cash'){
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#1996e3 ;"></span>'
			tip = tip + '<span>' + params[0].seriesName + ':</span>' + '<span style="font-weight:blod">' + this.NumericalTransformation(params[0].value)  + '</span>' + '<br>'
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#e9b82f ;"></span>'
			tip = tip + '<span>' + params[1].seriesName + ':</span>' + '<span style="font-weight:blod">' + params[1].value + '%'  + '</span>'
		}else if(type == 'precent'){
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#1996e3 ;"></span>'
			tip = tip + '<span>' + params[0].seriesName + ':</span>' + '<span style="font-weight:blod">' +  this.Decimal(params[0].value,2,true)  + '</span>' + '<br>'
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#e9b82f ;"></span>'
			tip = tip + '<span>' + params[1].seriesName + ':</span>' + '<span style="font-weight:blod">' + params[1].value + '%'  + '</span>'
		}else if(type == 'default'){
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#1996e3 ;"></span>'
			tip = tip + '<span>' + params[0].seriesName + ':</span>' + '<span style="font-weight:blod">' + params[0].value + '</span>' + '<br>'
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#e9b82f ;"></span>'
			tip = tip + '<span>' + params[1].seriesName + ':</span>' + '<span style="font-weight:blod">' + params[1].value + '%'  + '</span>'
		}else{
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#1996e3 ;"></span>'
			tip = tip + '<span>' + params[0].seriesName + ':</span>' + '<span style="font-weight:blod">' + params[0].value + '%' + '</span>' + '<br>'
			tip = tip + '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#e9b82f ;"></span>'
			tip = tip + '<span>' + params[1].seriesName + ':</span>' + '<span style="font-weight:blod">' + params[1].value + '%'  + '</span>'
		}

		return tip;
	}
}


export default connect(
	(state) => ({
		language: state.app.language,
		mdsToken: state.trade.mdsToken,
		marketParams: state.trade.marketParams,
		theme: state.app.theme
	}),
	(dispatch) => ({
		getgetFinancialsInfo: (p, c) => stockActions.getFinancialsDataAction(p, c),
	})
)(Financials);

